







































































/* eslint-disable */
import { Component, Prop, Vue } from 'vue-property-decorator'
import _ from 'lodash'
import { maskMoney } from '@/utils/common'

@Component
export default class ComponentDashboardGrupoRepasse extends Vue {
  @Prop(Boolean) exibirValores
  @Prop(Array) dataset
  @Prop(String) monthSelected
  @Prop(String) yearSelected

  maskMoneyUtil(value) {
    return maskMoney(value)
  }

  cor(index) {
    switch (parseInt(index)) {
      case 0:
        return '#03a5ed'
      case 1:
        return '#2652a3'
      case 2:
        return '#3ee9ff'
      case 3:
        return '#5b88da'
      case 4:
        return '#e9791a'
      case 5:
        return '#5783bc'
      case 6:
        return '#25f4e9'
      case 7:
        return '#ff9a3e'
      default:
        return '#03a5ed'
    }
  }

  radius: number = 1
  nominalStart: number = 0

  get runningCoords() {
    let start: any = this.nominalStart
    let i
    let total = 0

    for (i in this.dataset) total += this.dataset[i].valorBrutoTotal

    return this.dataset.map((slice) => {
      const _return = start
      start += (slice.valorBrutoTotal / total)
      return _return
    })
  }

  formatarPorcentagem(value) {
    return value.toFixed(2) || 0
  }

  drawSection(slice, index) {
    let i
    let total = 0
    for (i in this.dataset) total += this.dataset[i].valorBrutoTotal

    const { radius } = this
    const start = this.getCoordinatesForPercent(this.runningCoords[index], radius)
    const end = this.getCoordinatesForPercent(this.runningCoords[index] + (slice.valorBrutoTotal / total), radius)
    const largeArcFlag = (slice.valorBrutoTotal / total) > 0.5 ? 1 : 0

    return [
      `M ${start.join(' ')}`, // Move
      `A ${radius} ${radius} 0 ${largeArcFlag} 1 ${end.join(' ')}`, // Arc
      'L 0 0', // Line
    ].join(' ')
  }

  getCoordinatesForPercent(pct, radius) {
    const x = radius * Math.cos(2 * Math.PI * pct)
    const y = radius * Math.sin(2 * Math.PI * pct)
    return [x, y]
  }
}

